import { call, put, takeEvery } from 'redux-saga/effects';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';
import { downloadBase64File } from '../../../../utils/fileDownloads';
import { EXPORT_MODULE } from '../../../../constants/fileExport';
import * as types from './examMetricsActionType';
import * as actions from './examMetricsActions';
import * as services from './examMetricsService';

function* fetchExamMetricsMatrixSaga(action) {
	try {
		const response = yield call(services.getExamDataMatrixPagination, action.payload);
		if (!response) {
			throw new Error('No response received from matrix API');
		}

		yield put(actions.fetchExamMetricsMatrixSuccess(response?.values || {}));
	} catch (error) {
		yield put(actions.fetchExamMetricsMatrixFailure(error?.response?.data || 'Failed to fetch exam metrics matrix data.'));
	}
}

function* exportExamDataMatrixToCSVSaga(action) {
	try {
		const { fileName, ...payload } = action.payload || {};
		const response = yield call(services.exportExamDataMatrixToCSV, payload);

		const contentType = response.headers?.['content-type'] || '';
		if (contentType.includes('application/json')) {
			const errorText = yield response.data.text();
			const errorBody = JSON.parse(errorText);
			throw new Error(errorBody?.Message || errorBody?.message || 'Failed to export data.');
		}

		yield call(downloadBase64File, response.data, EXPORT_MODULE.EXAM_DATA, fileName);
		yield put(actions.exportExamDataMatrixToCSVSuccess());
		SweetAlert.success({
			title: 'Success!',
			text: 'Successfully exported data.'
		});
	} catch (error) {
		yield put(actions.exportExamDataMatrixToCSVFailure(error?.message || 'Failed to export data.'));
		SweetAlert.error({
			title: 'Error!',
			text: error?.message || 'Failed to export data.'
		});
	}
}

function* fetchExamMetricsDropdownSaga() {
	try {
		const response = yield call(services.getAllExamDataMatrixDropDown);
		if (!response) {
			throw new Error('No response received from dropdown API');
		}

		yield put(actions.fetchExamMetricsDropdownSuccess(response?.values || {}));
	} catch (error) {
		yield put(actions.fetchExamMetricsDropdownFailure(error?.response?.data || 'Failed to fetch exam metrics dropdowns.'));
	}
}

function* fetchExamMetricsDateRangeSaga() {
	try {
		const response = yield call(services.getLatestExamDateRange);
		if (!response) {
			throw new Error('No response received from latest date range API');
		}

		yield put(actions.fetchExamMetricsDateRangeSuccess(response?.values || {}));
	} catch (error) {
		yield put(actions.fetchExamMetricsDateRangeFailure(error?.response?.data || 'Failed to fetch latest exam metrics date range.'));
	}
}

export default function* watchExamMetricsSaga() {
	yield takeEvery(types.FETCH_EXAM_METRICS_MATRIX_REQUEST, fetchExamMetricsMatrixSaga);
	yield takeEvery(types.EXPORT_EXAM_METRICS_MATRIX_REQUEST, exportExamDataMatrixToCSVSaga);
	yield takeEvery(types.FETCH_EXAM_METRICS_DROPDOWN_REQUEST, fetchExamMetricsDropdownSaga);
	yield takeEvery(types.FETCH_EXAM_METRICS_DATE_RANGE_REQUEST, fetchExamMetricsDateRangeSaga);
}
